import { render, staticRenderFns } from "./Denunciante.vue?vue&type=template&id=446bb418&"
import script from "./Denunciante.vue?vue&type=script&lang=js&"
export * from "./Denunciante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports